import {
  GET_PROCESOS_REQUEST,
  GET_PROCESOS_SUCCESS,
  RESET_PROCESOS,
} from '../../actions/constants/procesos/procesos.constants';

const initialState = {
  loading: false,
  listado: [],
  total: 0,
  page: 1,
  start: 0,
  limit: 25,
  aprobado: true,
  archivado: false,
  tipoListado: 'listado_basico',
  sede: 1,
  desdeNc: false,
  procesosSeleccionados: [],
};

export default function procesosReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_PROCESOS_REQUEST: {
      return {
        ...state, loading: true,
      };
    }

    case GET_PROCESOS_SUCCESS: {
      const {
        datos, total, page, start, limit,
      } = payload;
      const { listado } = state;
      return {
        ...state, listado: [...listado, ...datos], total, loading: false, page, start, limit,
      };
    }

    case RESET_PROCESOS: {
      return {
        ...state, page: 1, start: 0, total: 25, listado: [],
      };
    }

    default:
      return state;
  }
}
